<template>
  <v-container
    id="manage-users"
    fluid
    tag="section"
  >
    <v-row
      class="d-flex"
    >
      <base-tile-card
        class="mx-3 pa-3"
      >
        <template v-slot:heading>
            Manage Users
        </template>
        <v-data-table
          :headers="headers"
          :items="users"
        >
          <template v-slot:item.is_staff="{ item }">
            <v-simple-checkbox
              v-model="item.is_staff"
              disabled
            ></v-simple-checkbox>
          </template>
          <template v-slot:item.created_at="{ item }">
            {{ formatEpoch(item.created_at) }}
          </template>
          <template v-slot:item.updated_at="{ item }">
            {{ formatEpoch(item.updated_at) }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-menu
              bottom
              close-on-click
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  Actions
                </v-btn>
              </template>

              <v-list>
                <v-list-item
                  v-if="item.is_staff"
                  link
                >
                  <v-list-item-title
                    @click="doSetStaff(item, false)"
                  >
                    Remove staff
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="!item.is_staff"
                  link
                >
                  <v-list-item-title
                    @click="doSetStaff(item, true)"
                  >
                    Make staff
                  </v-list-item-title>
                </v-list-item>
              </v-list>
              <v-list>
                <v-list-item
                  link
                >
                  <v-list-item-title
                    @click="doSendPasswordReset(item)"
                  >
                    Send Password Reset Email
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
        <v-dialog
          v-model="dialogResetEmailFlag"
          transition="dialog-bottom-transition"
          max-width="600"
        >
          <template>
            <v-card>
              <v-card-text>
                <div class="text-h2 pa-12">{{dialogResetEmailMessage}}</div>
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn
                  text
                  @click="dialogResetEmailFlag = false"
                >Close</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>

      </base-tile-card>
    </v-row>
  </v-container>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import {
    USER_GET_USERS, USER_SET_STAFF,
    PUBLIC_REQUEST_PASSWORD_RESET, _COMMIT_LOG,
  } from '../../store/actions.types'
  import basicMixin from '../../mixins/basic'
  // import interceptorsSetup from '../../helpers/axinstance'

  export default {
    name: 'ManageUsers',

    components: {
    },
    mixins: [basicMixin],

    data: () => ({
      headers: [
        {
          text: 'Email',
          align: 'start',
          sortable: false,
          value: 'email_address',
        },
        { text: 'First', value: 'first_name' },
        { text: 'Last', value: 'last_name' },
        { text: 'Staff', value: 'is_staff' },
        { text: 'Created', value: 'created_at' },
        { text: 'Updated', value: 'updated_at' },
        { text: 'Actions', value: 'actions' },
      ],
      dialogResetEmailFlag: false,
      dialogResetEmailMessage: '',
    }),
    computed: {
      ...mapGetters(['users', 'profile']),
    },
    watch: {
    },
    methods: {
      ...mapActions({
        commitLog: _COMMIT_LOG,
        getUsers: USER_GET_USERS,
        setStaffStatus: USER_SET_STAFF,
        sendPasswordReset: PUBLIC_REQUEST_PASSWORD_RESET,
      }),
      async doGetOrganizationMembers () {
        this.commitLog('doing login!')
        const members = await this.getOrganizationMembers(this.profile.organization_key)
        this.commitLog('Members:', members)
      },
      async doSetStaff (user, isStaff) {
        const response = await this.setStaffStatus({
          rowkey: user.rowkey,
          is_staff: isStaff,
        })
        this.commitLog(response)
        await this.getUsers()
      },
      async doSendPasswordReset (user) {
        this.commitLog({ message: 'Send Password Reset Email', user })
        try {
          const result = await this.sendPasswordReset({ email_address: user.email_address })
          this.commitLog({ message: 'Password Reset Request results', result })
          this.resetEmailSent = true
          this.dialogResetEmailFlag = true
          this.dialogResetEmailMessage = `Password reset email sent to ${user.email_address}`
        } catch (e) {
          this.dialogResetEmailFlag = true
          this.dialogResetEmailMessage = 'Password Reset Request exception'
          this.commitLog({ message: 'Password Reset Request exception', error: e })
        }
        await this.getUsers()
      },
    },
    mounted () {
      this.commitLog('Loading Manage Users page')
      this.getUsers()
    },
  }
</script>
